import { render } from "./LineTranscriptionModal.vue?vue&type=template&id=820cc07e&scoped=true"
import script from "./LineTranscriptionModal.vue?vue&type=script&lang=js"
export * from "./LineTranscriptionModal.vue?vue&type=script&lang=js"

import "./LineTranscriptionModal.vue?vue&type=style&index=0&id=820cc07e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-820cc07e"]])

export default __exports__